<template>
  <div class="SGT">
    <div class="nei_container w_1200">
      <div class="text_c">
        <div class="index_title">
          <div class="index_ts">审查指南</div>
        </div>
        <span class="index_tp">Review Guidelines</span>
      </div>
      <div class="newsbox">
        <div class="newsbox_li clearfix" @click="goToPage('/sf')">
          <div class="newsbox_liimg">
            <img src="../assets/sf.jpg" />
          </div>
          <div class="newsbox_litxt">
            <div class="t"><p>收费标准</p></div>
            <div class="date">2020-12-01</div>
            <div class="c">
              一、工业与民用建筑工程(含构筑物)
              二、市政工程及专项工程(含建筑装饰、幕墙、轻型钢结构、建筑智能化专项工程)
              三、说明 ...
            </div>
            <p class="newsbox_a">查看更多&gt;</p>
          </div>
        </div>
        <div class="newsbox_li clearfix" @click="goToPage('/lc')">
          <div class="newsbox_liimg">
            <img src="../assets/sc.png" />
          </div>
          <div class="newsbox_litxt">
            <div class="t"><p>审查工作流程</p></div>
            <div class="date">2020-12-01</div>
            <div class="c">
              1、 网上申报 2、 项目报审 3、 项目审查 4、 领取意见书 5、 回复修改
              6、 领取合格证 ..
            </div>
            <p class="newsbox_a">查看更多&gt;</p>
          </div>
        </div>
        <div class="newsbox_li clearfix" @click="goToPage('/nr')">
          <div class="newsbox_liimg">
            <img src="../assets/sf.jpg" />
          </div>
          <div class="newsbox_litxt">
            <div class="t"><p>审查内容</p></div>
            <div class="date">2020-12-01</div>
            <div class="c">
              1、是否符合工程建设强制性标准; 2、地基基础和主体结构的安全性;
              3、是否符合民用建筑节能强制性标准，...
            </div>
            <p class="newsbox_a">查看更多&gt;</p>
          </div>
        </div>
        <div class="newsbox_li clearfix" @click="goToPage('/fw')">
          <div class="newsbox_liimg">
            <img src="../assets/sc.png" />
          </div>
          <div class="newsbox_litxt">
            <div class="t"><p>审查范围</p></div>
            <div class="date">2020-12-01</div>
            <div class="c">
              1、
              住宅小区、工厂生活区、地下工程，三层及以上的住宅工程(含建制镇、集镇
              规划建设用地范围); 2、 建筑面积在 300 ...
            </div>
            <p class="newsbox_a">查看更多&gt;</p>
          </div>
        </div>
        <!-- <div class="newsbox_li clearfix" @click="goToPage('/cl')">
          <div class="newsbox_liimg">
            <img src="../assets/sc.png" />
          </div>
          <div class="newsbox_litxt">
            <div class="t">
              <p>报审材料</p>
            </div>
            <div class="date">2020-12-01</div>
            <div class="c">
              1、 施工图审查委托书; 2、 立项批文; 3、 建设工程规划许可证...
            </div>
            <p class="newsbox_a">查看更多&gt;</p>
          </div>
        </div> -->
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {};
  },
  mounted() {
    console.log("$router.path:", this.$route.path);
  },
  methods: {
    goToPage(path) {
      this.$router.push({ path });
    },
  },
};
</script>
<style lang="scss" scoped>
.SGT {
  .nei_container {
    margin: 25px auto;
    width: 1200px;
    .text_c {
      text-align: center;
      .index_title {
        font-size: 30px;
        line-height: 50px;
        position: relative;
        text-align: center;
        &::before {
          display: block;
          height: 1px;
          top: 50%;
          width: 100%;
          left: 0px;
          background: #d7d7d7;
          position: absolute;
          content: "";
        }
        .index_ts {
          display: inline-block;
          font-size: 24px;
          background: #fff;
          padding: 0px 50px;
          position: relative;
          z-index: 1;
        }
      }
      .index_tp {
        display: inline-block;
        font-size: 18px;
        background: #fff;
        padding: 0px 50px;
        position: relative;
        z-index: 1;
        color: #ccc;
        margin-top: -5px;
      }
    }
    .newsbox {
      margin: 20px auto;
      padding: 20px 0px;
      border-top: 1px solid #d7d7d7;
      .newsbox_li {
        padding: 20px 0px;
        border-bottom: 1px solid #d7d7d7;
        cursor: pointer;
        .newsbox_liimg {
          width: 225px;
          float: left;
          img {
            display: block;
            width: 100%;
          }
        }
        .newsbox_litxt {
          margin-left: 260px;
          .t {
            font-size: 18px;
            font-weight: bold;
            height: 30px;
            line-height: 30px;
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: nowrap;
          }
          .date {
            margin: 5px 0px;
            font-size: 14px;
            color: #999;
          }
          .c {
            margin: 10px 0px;
            font-size: 14px;
            line-height: 22px;
            color: #666;
            height: 44px;
            overflow: hidden;
          }
          .newsbox_a {
            display: block;
            width: 85px;
            height: 25px;
            border: 1px solid #1a6fc9;
            font-size: 14px;
            line-height: 25px;
            color: #1a6fc9;
            text-align: center;
          }
        }
      }
    }
  }
}
</style>